var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  pluginRegistry.registerFeature("Octopus.Features.Vhd", function(busy, octopusRepository) {
    return {
      title: "Vhd",
      description: "Allows other features to be performed on the contents of a VHD before optionally attaching it to a Virtual Machine",
      editTemplateUrl: "areas/projects/features/Octopus.Features.Vhd_edit.html",
      priority: 1,
      editLink: function($scope, element) {
      },
      enable: function(action, step) {
      },
      disable: function(action, step) {
      },
      validate: function(action, step, errors) {
        if (action.Properties["Octopus.Action.Vhd.DeployVhdToVm"] && !action.Properties["Octopus.Action.Vhd.VmName"]) {
          errors.push("Please enter a name for the Virtual Machine.");
        }
        if (!action.Properties["Octopus.Action.Vhd.ApplicationPath"]) {
          errors.push("Please enter an application path for this VHD.");
        }
      },
    };
  });

});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.Vhd.js
// module id = 5079504603933778
// module chunks = 1